$(() => {
  const dropdown = $('#review-filter-dropdown');

  const outsideClickListener = e => {
    if (!dropdown[0].contains(e.target)) {
      dropdown.attr('hidden', true);
    }
  };

  $('.review-filter-button > button.btn').click(e => {
    e.stopPropagation();
    // If dropdown is hidden
    if (dropdown.attr('hidden')) {
      dropdown.attr('hidden', false);
      document.addEventListener('click', outsideClickListener);
    } else {
      dropdown.attr('hidden', true);
      document.removeEventListener('click', outsideClickListener);
    }
  });
});
